import React, {
  ChangeEvent,
} from 'react';
import clsx from 'clsx';
import noop from 'lodash/noop';
import isNil from 'lodash/isNil';
import {
  formatDate,
} from 'utils/date';
import {
  Dayjs,
} from 'utils/dayjs';
import {
  eventTypeTitles,
} from 'pages/Dashboard/pages/Appointments/pages/List/utils/helper';
import {
  CalendarEvent,
} from 'pages/Dashboard/pages/Appointments/pages/List/types/appointment';
import Button from 'pages/Dashboard/components/Button';
import Dialog from 'pages/Dashboard/components/Dialog';
import RecurringActionOptions from 'pages/Dashboard/pages/Appointments/pages/List/components/Details/RecurringActionOptions';

function getDeleteTitle(
  { isTimeAvailability, typeName }: CalendarEvent,
  eventDate: Dayjs,
) {
  return `Delete ${eventTypeTitles[typeName ?? 'appointment']} ${
    isTimeAvailability
      ? formatDate(eventDate)
      : ''}`;
}

function ConfirmDeleteContent({
  typeName,
  isTimeBlock,
  isTimeAvailability,
}: CalendarEvent) {
  const isAppointment = !isTimeAvailability && !isTimeBlock;
  return (
    <>
      <p className={clsx({ 'font-semibold': isAppointment })}>
        Are you sure you want to delete this
        {' '}
        {eventTypeTitles[typeName ?? 'appointment']}
        ?
      </p>
      {isAppointment && (
        <p className="mb-4 italic">
          Any associated Visit Note will also be deleted if not finalized.
        </p>
      )}
    </>
  );
}
export type DeleteConfirmationParams = {
  data: CalendarEvent;
  eventDate: Dayjs;
};

type Props = DeleteConfirmationParams & {
  deleteOptionValue: string;
  onDeleteOptionChange: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
  onConfirm: (data: CalendarEvent, eventData?: Dayjs, value?: string) => void;
  onClose: () => void;
};
export default function DeleteConfirmation({
  data,
  deleteOptionValue,
  eventDate,
  onConfirm,
  onClose,
  onDeleteOptionChange,
}: Props) {
  const isRecurring = !isNil(data?.recurrence);

  return (
    <Dialog
      open
      title={getDeleteTitle(data, eventDate)}
      onClose={onClose}
      onConfirm={noop}
      showActions={false}
    >
      {isRecurring
        ? (
          <RecurringActionOptions
            value={deleteOptionValue}
            onChange={onDeleteOptionChange}
            type={data.typeName ?? 'availability'}
          />
        ) : <ConfirmDeleteContent {...data} />}
      <div className="flex justify-end items-center space-x-2 nw-confirmation-dialog-buttons">
        <Button
          variant="outlined"
          type="button"
          onClick={onClose}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={() => { onConfirm(data, eventDate, deleteOptionValue); }}
        >
          Confirm
        </Button>
      </div>
    </Dialog>
  );
}
